import axios from '@/plugins/axios'

const axiosInformaGiovani = {
  install (Vue) {
    if (!Vue.prototype.hasOwnProperty('axios')) {
      Vue.use(axios)
    }
    Vue.prototype.axios.agilisUrlSaveInformaGiovaniRegistration = function () { return `/api/public/informagiovani/tracker/publicRegistration` }
    Vue.prototype.axios.agilisUrlConfigurationInformaGiovaniForm = function () { return `/api/public/configuration/informagiovani/tracker/publicRegistration` }
  }

}

export default axiosInformaGiovani
